import { FieldValues, PasswordElement, PasswordElementProps } from 'react-hook-form-mui';

function InputPassword<T extends FieldValues>(props: PasswordElementProps<T>) {
  return <PasswordElement {...props} />;
}

export default InputPassword;
